



















































































































import { Pages } from '@/pages'
import { errorHandler, getUrl } from '@/api/utils/http-helpers.js'
import { About, ISnackbar } from '@/model/index'
import NavButton from '@/components/shared/NavButton'
import moment from 'moment'
import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  components: {
    NavButton: NavButton,
  },
  computed: mapState('environment', [
    'chromeKioskModeDetected',
  ])
})

export default class AboutView extends Vue {
  private about: About = {}
  private homeRouteLink: any = Pages.HOME.routeLink
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }
  private loadingZip: boolean = false

  private mounted () {
    const url = getUrl('/about')
    axios.get(url, { timeout: 3000 })
      .then(resp => {
        this.about = resp.data as About
      })
      .catch(e => {
        errorHandler(e)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = 'Failed to load version information'
      })
  }

  private loadZip () {
    this.loadingZip = true
    setTimeout(() => {
      this.loadingZip = false
    }, 3000)
  }

  get logsUrl (): string {
    return getUrl('/log')
  }

  get dataTableItems () {
    const versionString = this.about.version || 'n/a'
    const startTimeString = this.about.startTime ? moment(this.about.startTime).format('L LT') : 'n/a'
    let uptimeString = 'n/a'
    if (this.about.uptime) {
      // start with milliseconds
      let value = this.about.uptime
      const days = Math.floor(value / 86400000)
      value = value % 86400000
      const hours = Math.floor(value / 3600000)
      value = value % 3600000
      const minutes = Math.floor(value / 60000)
      value = value % 60000
      const seconds = Math.floor(value / 1000)
      if (days || hours || minutes || seconds) {
        uptimeString = (days ? days + ' ' + this.$t('general.days') + ' ' : '') +
          (hours ? hours + ' ' + this.$t('general.hours') + ' ' : '') +
          (minutes ? minutes + ' ' + this.$t('general.minutes') + ' ' : '') +
          (seconds ? seconds + ' ' + this.$t('general.seconds') + ' ' : '')
      }
    }
    return [
      {
        name: this.localText('about.version'),
        value: versionString
      },
      {
        name: this.localText('about.startTime'),
        value: startTimeString
      },
      {
        name: this.localText('about.upTime'),
        value: uptimeString
      }
    ]
  }

  get qrCodeImageUrl (): string {
    return getUrl('/about/qr-code')
  }

  private localText (b: string): string {
    return String(this.$t(b))
  }

  private showDocumentation() {
    this.$router.push(Pages.DOCUMENTVIEWER.routeLink)
  }

}
